// Table
import Table from '../ui/table/Table'

// UI
import { Anchor } from '@mantine/core'
import Badge from '@/components/ui/Badge'

// Next
import { Link } from 'react-router-dom'

// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

// Dayjs
import dayjs from 'dayjs'

// Status
import { getInvoiceStatus, invoice_statuses } from '@/lib/retailerStatuses'

// Lodash OrderBy
import orderBy from 'lodash/orderBy'

// Cells
const NameCell = (item) => (
    <Link
        to={`/retailer_invoices/${item.id}`}
        className="table-cell p-5 hover:bg-gray-100"
    >
        <div className="flex gap-6 items-center">
            <div className="flex flex-col items-start">
                <Anchor component="span">{item.number}</Anchor>

                <span className="text-gray-500 text-sm">
                    {dayjs(item.date).format('ll')}
                </span>
            </div>
        </div>
    </Link>
)

const RetailerCell = (item) => (
    <Link
        to={`/retailers/${item.retailer.id}`}
        className="table-cell p-5 hover:bg-gray-100 align-middle"
    >
        <div className="flex gap-6 items-center">
            <div className="flex flex-col items-start">
                <Anchor component="span">{item.retailer.name}</Anchor>
            </div>
        </div>
    </Link>
)

const StatusCell = (item) => {
    const status = getInvoiceStatus(item.status)

    return (
        <div className="table-cell p-5 align-middle text-sm">
            <Badge color={status.badgeColor}>{status.label}</Badge>
        </div>
    )
}

const TotalCell = (item) => (
    <div className="table-cell p-5 align-middle">
        <span className="text-gray-500 text-sm uppercase">
            {new Intl.NumberFormat('fr-FR', {
                style: 'currency',
                currency: 'EUR',
            }).format(item.amounts.total_incl_tax)}
        </span>
    </div>
)

export default function RetailerInvoiceTable() {
    const availableColumns = [
        {
            name: 'Nom',
            key: 'sellsy_id',
            display: 'mandatory',
            sortable: true,
            component: NameCell,
        },
        {
            name: 'Revendeur',
            key: 'retailer',
            display: 'optional_default',
            sortable: false,
            component: RetailerCell,
        },
        {
            name: 'Statut',
            key: 'status',
            display: 'optional_default',
            sortable: false,
            component: StatusCell,
        },
        {
            name: 'Total TTC',
            key: 'total',
            display: 'optional_default',
            sortable: false,
            component: TotalCell,
        },
    ]

    // Load filters options
    const { data: retailers } = useApiSWRReference('/retailers/list')

    const statusOptions = orderBy(
        Object.keys(invoice_statuses).map((key) => ({
            label: invoice_statuses[key].label,
            value: key,
        })),
        'label'
    )

    const availableFilters = [
        {
            name: 'Revendeur',
            key: 'retailer_id',
            type: 'multiselect',
            placeholder: 'Filter par revendeur...',
            options: retailers?.map((retailer) => ({
                label: retailer.name,
                value: retailer.id.toString(),
            })),
        },
        {
            name: 'Statut',
            key: 'status',
            type: 'multiselect',
            placeholder: 'Filter par statut...',
            options: statusOptions,
        },
    ]

    return (
        <Table
            engineApiEndpoint="retailer-invoices"
            availableColumns={availableColumns}
            availableFilters={availableFilters}
            searchable={false}
            defaultSortColumn="sellsy_id"
            defaultSortDirection="desc"
        />
    )
}
